import * as customerTypes from '../types/Customer';
import * as customerValidator from './Validators/CustomerValidator';
import * as errorActions from './Error';
import {getComplaintsTypesDictionary} from './Util';
import { changePageToCreateComplaintPositions,changePageToCreateComplaintPosition,changePageToCreateSingleComplaintPosition } from './Page';
import {IS_INTERNAL_APP} from '../api/ApiSettings';

//Action which allows to change the customer address building number
export function changeBuildingNumber(buildingNumber) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_BUILDING_NUMBER,
        payload: { buildingNumber: buildingNumber }
    };
}

//Action which allows to change the customer address city
export function changeCity(city) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_CITY,
        payload: { city: city }
    };
}

//Action which allows to change the customer address country
export function changeCountry(country) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_COUNTRY,
        payload: { country: country }
    };
}


//Action which allows to change the customer email
export function changeEmail(email) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_EMAIL,
        payload: { email: email }
    };
}

//Action which allows to change the customer conpany tax
export function changeTax(tax) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_TAX,
        payload: { companyTax: tax }
    };
}

//Action which allows to change the customer company name
export function changeCompanyName(companyName) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_COMPANY_NAME,
        payload: { companyName: companyName }
    };
}

//Action which allows to change the customer address flat number
export function changeFlatNumber(flatNumber) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_FLAT_NUMBER,
        payload: { flatNumber: flatNumber }
    };
}

//Action which allows to change the customer name
export function changeName(name) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_NAME,
        payload: { name: name }
    };
}

export function changeSurname(surname){
    return {
        type: customerTypes.CUSTOMER_CHANGE_SURNAME,
        payload: { surname: surname }
    };
}

//Action which allows to change the customer address phone
export function changePhone(phone) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_PHONE,
        payload: { phone: phone }
    };
}

export function changePhoneCode(phoneCode) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_PHONE_CODE,
        payload: { phoneCode: phoneCode }
    };
}

//Action which allows to change the customer address postal code
export function changePostalCode(postalCode) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_POSTAL_CODE,
        payload: { postalCode: postalCode }
    };
}

//Action which allows to change the customer address street
export function changeStreet(street) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_STREET,
        payload: { street: street }
    };
}

//Action which allows to change the customer type
export function changeType(type) {
    return {
        type: customerTypes.CUSTOMER_CHANGE_TYPE,
        payload: type
    };
}

//Action which allows to change the new customer flag
export function changeNewCustomer() {
    return {
        type: customerTypes.CUSTOMER_CHANGE_NEW_CUSTOMER,
    };
}

//Action which create action which allows init the customer address properties by selected company
export function initDataBySelectedCompany() {
    return (dispatch, getState) => {
        const company = getState().company.selectedRow;
        dispatch(initDataByCompany(company));
      };
}

export function initDataBySelectedCompanyForPurchaseAddress() {
    return (dispatch, getState) => {
        const company = getState().company.selectedRow;
        dispatch(initDataByCompanyForPurchaseAddress({
            id:company.id,
            companyName:company.companyName
        }));
      };
} //CODE REVIEW

function initDataByCompanyForPurchaseAddress(company) {
    return {
        type: customerTypes.CUSTOMER_INIT_BY_COMPANY_FOR_PURCHASE_ADDRESS,
        payload: company
    };
}
//Action which allows init the customer address properties by company
function initDataByCompany(company) {
    return {
        type: customerTypes.CUSTOMER_INIT_BY_COMPANY,
        payload: company
    };
}

function changeCustomerTypeToCompany() {
    return {
        type: customerTypes.CUSTOMER_CHANGE_TYPE_TO_COMPANY
    };
}

export function changeCustomerTypeToCorporateEntity() {
    return (dispatch, getState) => {
        const customer = getState().customer;
        if (customer.type.value=== 'Company') {
            return dispatch({ type: customerTypes.CUSTOMER_CHANGE_TYPE_TO_CORPORATE_ENTITY });
        }
    };
}

export function validateCustomer() {
    return (dispatch, getState) => {
        dispatch(errorActions.clearError());
        const customer = getState().customer;
        const company = getState().company;
        let companyCode = "";
        if (company.selectedRow && company.selectedRow.code) {
            companyCode = company.selectedRow.code;
        }
        dispatch(validate(customer));
        try {
            if(IS_INTERNAL_APP === false) {
                customerValidator.validateCustomerName(customer.name);
                customerValidator.validateCustomerPhone(customer.phone);
                customerValidator.validateCustomerEmail(customer.email);
            }
            customerValidator.validateCustomerName(customer.name);
            customerValidator.valudateCustomerSurname(customer.surname);
            customerValidator.validateCustomerEmail(customer.email);
            // customerValidator.validatePhoneCode(customer.phoneCode);
            customerValidator.validateCustomerPhone(customer.phone);
            //customerValidator.validateCustomerType(customer.type.value);
            customerValidator.validateCustomerStreet(customer.street);
            customerValidator.validateCustomerCity(customer.city);
            customerValidator.validateCustomerPostalCode(customer.postalCode);

            // if(customer.type.value==="CorporateEntity") {
            //     customerValidator.validateCustomerCompanyName(customer.companyName);
            //     customerValidator.validateCustomerCompanyTaxId(customer.companyTax);
            // } else if(customer.type.value==="Company") {
            //     customerValidator.validateCustomerTaxId(customer.companyTax);
            //     customerValidator.validateCustomerCompanyName(customer.companyName);
            // }
            // if(customer.type.value==="CorporateEntity") {
            //     if(customer.newCustomer || isCustomerIndividualClient(companyCode)){
            //         dispatch(changeCustomerTypeToCompany(customer.type));
            //     }
            // }

            if (getState().util.allowMultiplePositionsForComplaint) {
                return dispatch(changePageToCreateComplaintPositions());
            }
            return dispatch(changePageToCreateSingleComplaintPosition());
        } catch (error) {
            return dispatch(errorActions.throwNewError("Błąd walidacji", error.message)); 
        }
    };
}

//Action which create action which allows validate customer data
function validate(customer) {
    return {
        type: customerTypes.CUSTOMER_VALIDATE,
        customer: customer
    };
}

//Is customer indyvidual client.
function isCustomerIndividualClient(customerCode) {
    return customerCode.startsWith("INDYW");
}




// WEBPACK FOOTER //
// ./src/actions/Customer.js